import { saveAs } from 'file-saver';

export interface VCardParams {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
  email?: string;
  jobTitle?: string;
}

export function useVCard() {
  const canUseVCard = () => {
    const userAgent = navigator.userAgent;
    const isAppleDevice = /iPad|iPhone|iPod/.test(userAgent);
    const isChrome = /Chrome/.test(userAgent);
    const isFirefox = /Firefox/.test(userAgent);

    return isChrome || isFirefox || isAppleDevice;
  };

  function saveVCard(stringData: string, filename: string) {
    const blob = new Blob([stringData], {
      type: 'text/x-vCard;charset=iso-8859-1',
    });
    saveAs(blob, filename);
  }

  function buildVCardString({
    firstName,
    lastName,
    phoneNumber,
    street,
    city,
    state,
    zip,
    email,
    jobTitle,
  }: VCardParams) {
    const strStart = 'BEGIN:VCARD\nVERSION:3.0';
    const strEnd = '\nEND:VCARD';
    let nameString = '';
    let numberString = '';
    let addressString = '';
    let emailString = '';
    let jobTitleString = '';

    if (firstName || lastName) {
      nameString = `\nN:${lastName};${firstName};;;\nFN:${firstName} ${lastName}`;
    }

    if (phoneNumber) {
      numberString = `\nTEL;TYPE#HOME,VOICE:${phoneNumber}`;
    }

    if (street || city || state || zip) {
      addressString = `\nADR;TYPE#HOME:;;${street};${city};${state};${zip};United States of America`;
    }

    if (email) {
      emailString = `\nEMAIL:${email}`;
    }

    if (jobTitle) {
      jobTitleString = `\nTITLE:${jobTitle}`;
    }

    return (
      strStart +
      nameString +
      numberString +
      addressString +
      emailString +
      jobTitleString +
      strEnd
    );
  }

  return {
    canUseVCard,
    buildVCardString,
    saveVCard,
  };
}
